import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/sideBar/icon_halloweenExpedition_1.png")